<template>
  <analytics-sub-page
    title="Loans Analytics"
    icon="hand-holding-dollar"
    css-class="analytics-loans"
    default-label="Loans"
    :section-specs="sectionSpecs"
  >
    <sdl-metrics ref="sdlRef" />
  </analytics-sub-page>
</template>

<script setup>
import { ref } from 'vue';
import AnalyticsSubPage from '@/components/AnalyticsSubPage.vue';
import SdlMetrics, { sdlMetricsSections } from '@/pages/analyticsApp/components/SdlMetrics.vue';

const sdlRef = ref(null);

// SdlMetrics carves itself into two logical subsections (the over-time "Loans"
// chart and the "Loan details" stat row). The section descriptors live with
// the component so this tab and the homepage "Download all" capture stay in
// sync.
const sectionSpecs = sdlMetricsSections(sdlRef);
</script>
